import * as XLSX from "xlsx";
import { SiMicrosoftexcel } from "react-icons/si";
import { Tooltip } from "@mui/material";

function ExcelDownloadButton({ data, fileName = "export" }) {
  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <Tooltip title="Download Excel" arrow>
      <button
        onClick={handleDownload}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #2db7e8 0%, #0288d1 100%)",
          border: "none",
          color: "#fff",
          padding: "8px 10px",
          borderRadius: "8px",
          cursor: "pointer",
          boxShadow: "0 3px 8px rgba(0, 0, 0, 0.15)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.08)";
          e.currentTarget.style.boxShadow = "0 6px 14px rgba(0, 0, 0, 0.25)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 3px 8px rgba(0, 0, 0, 0.15)";
        }}
      >
        <SiMicrosoftexcel size={22} style={{ marginRight: 5 }} />
        <span style={{ fontWeight: 500 }}>Excel</span>
      </button>
    </Tooltip>
  );
}

export default ExcelDownloadButton;
